/*
 * @description: 订单备注
 */
import { useState, useCallback } from 'react';

type SetDataType = {
  remark: string;
  orderRemarkTag: string[];
};
export default function OrderCenterSameCityOrderRemark() {
  // 订单备注下拉选择
  const [orderRemarkTag, setOrderRemarkTag] = useState<string[]>([]);
  const setOrderRemarkTagM = useCallback((val) => {
    setOrderRemarkTag(val);
  }, []);

  // 订单备注输入框
  const [remark, setRemark] = useState('');
  const setRemarkM = useCallback((val) => {
    setRemark(val);
  }, []);

  // 更新所有数据
  const set = useCallback((val: SetDataType) => {
    setOrderRemarkTag(val.orderRemarkTag);
    setRemark(val.remark);
  }, []);

  //  清空数据
  const reset = useCallback(() => {
    setOrderRemarkTag([]);
    setRemark('');
  }, []);

  return {
    orderRemarkTag,
    setOrderRemarkTagM,
    remark,
    setRemarkM,
    set,
    reset,
  };
}
